<template>
  <div class="app" v-cloak>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style lang="scss">
[v-cloak] {
  display: none;
}

* {
  box-sizing: border-box;
}

body {
  overscroll-behavior: none;
  -webkit-overflow-scrolling: auto;
  color: #333;
  font-family: 'PMingLiU', sans-serif !important;
}

.app {
  min-height: 100vh;
  max-height: 100%;
}

.mian {
  padding-top: 50px;
  font-size: 14px;
}

.view {
  font-size: 14px;
  min-height: 100vh;
  max-height: 100%;
}

.ash {
  min-height: 100vh;
  max-height: 100%;
  background: #F3F4F6;
}


body::-webkit-scrollbar,
html::-webkit-scrollbar,
.app::-webkit-scrollbar,
.view::-webkit-scrollbar,
.mian::-webkit-scrollbar {
  display: none;
}

.imagecss {
  width: 100%;
  height: 100%;
  vertical-align: top;
  object-fit: contain;
  will-change: transform,
}

.box {
  width: 100%;
  position: relative;
  padding: 0 30px;
  padding-bottom: 30px;
  font-size: 13px;
  text-align: justify;
  white-space: pre-wrap;
  line-height: 1.5;
  overflow: hidden;
}

/deep/ .el-message {
  z-index: 9999;
}
</style>
